import _ from 'lodash'
import {populateEvent, saveEvent, saveNewEvent, doCsvUploadForEvent} from '../api'

export const loadEvent = ({ state, commit }, {uuid, loadDataFromServer}) => {
  if (loadDataFromServer || _.isEmpty(state.event)) {
    return populateEvent(uuid).then((response) => {
      commit('LOAD_EVENT', response)
      return response
    })
  } else {
    commit('LOAD_EVENT', state.event)
    return state.event
  }
}

export const storeEvent = ({ state, commit }, eventObj) => {
  if (!eventObj.uuid) {
    return saveNewEvent(eventObj).then((response) => {
      commit('LOAD_EVENT', response)
      return response
    })
  }
  return saveEvent(eventObj).then((response) => {
    commit('LOAD_EVENT', response)
    return response
  })
}

export const uploadEventCsvFile = ({ state, commit }, {institutionId, createdByUuid, folderId, fileData}) => {
  return doCsvUploadForEvent(institutionId, createdByUuid, folderId, fileData).then(res => {
    return res
  })
}



// WEBPACK FOOTER //
// ./src/app/event/vuex/actions.js